import React, { useState } from 'react'
import moment from 'moment'
import { useWeb3React } from '@web3-react/core'
import { providers } from 'ethers'
import { useBonusContract } from './useContract'
import { useDispatch } from 'react-redux'
import { displayCurrency, transformToEther, displayEtherDecimal ,displayDecimal } from '../utils/helpers'
import { ITransection } from '../models/bonus.interface'
import { setStateKey ,setTotalAvailable } from '../redux/slices/bonusSlice'
import { useModalStatus } from "./useModalStatus"


export const useBonus = () => {
    const { account, library } = useWeb3React<providers.Web3Provider>()
    const [totalBonus, setTotalBonus] = useState<number>(0)

    const dispatch = useDispatch()
    const contract = useBonusContract()

    const { 
        setShowModalStaus, 
        modalStatusState ,
        setCloseModalStatus,
        STATUS_TYPE,
        setModalForHandleError
    } = useModalStatus()

    const getBalanceAvailable = async (address: string) => {
        try {
            const result = await contract.getBalanceAvailable()
            const balanceAvailable: string = displayEtherDecimal(result, 2)

            // dispatch(setStateKey({ key: 'totalAvailable', value: balanceAvailable}))
        } catch (ex) {
            console.log(ex)
        }
    }

    const contributeBalance = async() =>  {
        await contributeBalanceAddress(account)
    }

    const contributeBalanceAddress = async (address: string) => {
        try {
            const items = await contract.getContributorBalance(address)

            let totalBonus: number = 0
            let totalAvailable: number = 0
            const arrTrans: ITransection[] = []
            var dealDate: string = ''

            for(let item of items) {
                const { id, airDropValue, _airDropRate, status, timeToWithdraw, timestamp } = item

                const id_: number = id ? Number(id) : 0
                const airDropValue_: string = airDropValue ? String(displayEtherDecimal(airDropValue, 2)) : "0"  // Bonus value
                const airDropRate_: number = _airDropRate ? Number(_airDropRate) : 100   
                const airDropRate2: number = (airDropRate_ + 100) / 100
                const timestamp_ = timestamp ? Number(timestamp) : 0
                const timeToWithdraw_ = timeToWithdraw ? Number(timeToWithdraw) : 0
                const status_: boolean = status ?? false
                var isClaim: boolean = false
                var desc: string = ""
                const dateNow: number = Number(moment().format('X'))    // timestamp

                if (airDropRate_ > 0) {
                    if (status_) {
                        const airDrop = transformToEther(airDropValue ?? 0)
                        totalBonus += airDrop
                        if (dateNow >= timeToWithdraw_ ?? 0) {
                            totalAvailable += airDrop
                            desc = "claim the bonus now"
                            isClaim = true
                            dealDate = ''
                        } else {
                            const strDate: string = moment.unix(timeToWithdraw_).format('DD MMM yyyy HH:mm')
                            desc = `*You can claim the bonus after ${strDate}`
                            if (dealDate == '' && totalAvailable == 0) {
                                dealDate = `*Earn the next bonus after ${strDate}`
                            }
                        }
                    }
                    
                    
                    const tran: ITransection = {
                        id: id_,
                        airDropValue: airDropValue_,
                        airDropRate: airDropRate2,
                        isClaim: isClaim,
                        description: desc,
                        status: status,                    
                    }
                    arrTrans.push(tran)    
                }
            }

            const hasBonus: boolean = totalBonus > 0
            const updateParams = {
                totalAvailable :  displayDecimal(totalAvailable),
                totalBonus :  displayDecimal(totalBonus),
                transection: arrTrans,
                hasBonus, 
                dealDate,
            }
            dispatch(setTotalAvailable(updateParams))

            return arrTrans
        } catch (ex) {
            console.log(ex)
        }
    }

    const withDrawAvailableBalance = async() =>  {

        setShowModalStaus(STATUS_TYPE.WAITING)

        try {
            const result = await contract.withdrawAvailable()

            const resultConfirm = await result.wait()

            if (resultConfirm.status === 1) {
                contributeBalance()
                setShowModalStaus(STATUS_TYPE.SUCCESS)
            } else {
                throw new Error('Transfer failed')
            }

        } catch (error) {
            setModalForHandleError(error)
        }
    }

    return {
        getBalanceAvailable,
        contributeBalance,
        contributeBalanceAddress,
        withDrawAvailableBalance,
    }
}